export default __webpack_public_path__ + "static/media/Croissant-Chocolate.c7fce14e.jpg";